<form id="multi-branch-selector-form">
  <label for="multiBranchSelector" id="multi-branch-selector-heading" class="h-4 mb-3"
  >My Branches</label
  >

  <ng-select
    [items]="groupedBranches"
    [multiple]="true"
    bindLabel="name"
    bindValue="id"
    [placeholder]="placeholder"
    [formControl]="formControl"
    [closeOnSelect]="false"
    (blur)="onBlur()"
    (change)="onSelectionChange($event)"
  >
    <ng-template ng-option-tmp let-item="item">
      <input
        *ngIf="item.type === 'option'"
        type="checkbox"
        [checked]="formControl.value?.includes(item.id)"
      />
      {{ item.name }}
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="ng-value" *ngIf="allSelected">
        <span class="ng-value-label">All Branches</span>
        <span class="ng-value-icon right" (click)="clearAll()" aria-hidden="true"
        >×</span
        >
      </div>

      <ng-container *ngIf="!allSelected">
        @for (item of items; track item) {
          <div class="ng-value">
            <span class="ng-value-label">{{ item.name }}</span>
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
            >×</span
            >
          </div>
        }
      </ng-container>
    </ng-template>
  </ng-select>

  <div *ngIf="formControl.errors?.['minlength']" class="error">
    At least one geozone is required.
  </div>

</form>
